import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const Container = styled.div``;

const Title = styled.h1`
  text-align: center;
  margin: 0 0 16px 0;
  color: rgb(104 38 85);
  @media (max-width: 700px) {
  }
`;

const CardiacRehabilitation: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container className="cardiacRehabilitation">
      <Title>{t("whatWeDo.cardiacRehabilitation.title").toUpperCase()}</Title>
    </Container>
  );
};

export default CardiacRehabilitation;
